import React from 'react';
import PropTypes from 'prop-types';

import FusionCharts from 'fusioncharts';
import FusionTheme from 'fusioncharts/themes/fusioncharts.theme.fusion';
import ExcelExport from 'fusioncharts/fusioncharts.excelexport';
import ReactFC from 'react-fusioncharts';

import LoadingSpinner from 'components/LoadingSpinner';
import { Message } from 'components/shared';
import FCCharts from 'fusioncharts/fusioncharts.charts';
import ButtonNavigation from './components/ButtonNavigation';

ReactFC.fcRoot(FusionCharts, FCCharts, FusionTheme, ExcelExport);

const PortfolioMainExposureChart = ({
  state,
  dataSource,
  setQueryParam,
  queryParam,
  forwardRef
}) => {
  const { isLoading, isError, error } = state;

  const { returnData } = queryParam;

  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (isError) {
    return <Message type="error" text={error} />;
  }

  return (
    <>
      <ButtonNavigation returnData={returnData} setQueryParam={setQueryParam} />

      <ReactFC
        type="stackedcolumn2d"
        width="100%"
        height="220"
        dataFormat="JSON"
        dataSource={dataSource}
        ref={forwardRef}
      />
    </>
  );
};

PortfolioMainExposureChart.propTypes = {
  forwardRef: PropTypes.shape({}),
  dataSource: PropTypes.shape({}),
  state: PropTypes.shape({
    isLoading: PropTypes.bool,
    isError: PropTypes.bool,
    error: PropTypes.string
  }),
  setQueryParam: PropTypes.func,
  queryParam: PropTypes.shape({
    returnData: PropTypes.string
  })
};
PortfolioMainExposureChart.defaultProps = {
  state: {},
  setQueryParam: null,
  queryParam: {},
  dataSource: {},
  forwardRef: null
};

export default PortfolioMainExposureChart;
